import React from 'react';
import { ModelMapEditor } from '@leverege/ui-plugin';
import { List, Text, Pane, Popup, Checkbox } from '@leverege/ui-elements';
import PlacementEditor from "./PlacementEditor.js";
import Model from './SelectionTypeModel.js';
import S from './SelectionTypeRenderer.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function SelectionTypeRenderer(props) {
  const {
    item,
    onEvent,
    onParentChange,
    ...rest
  } = props;
  const [key, value] = item;
  const name = value.name || key; // maybe use a type lookup hear...datasource?

  const onChange = e => {
    const nModel = Model[e.data](value, e.value);
    onEvent({
      type: ModelMapEditor.EVT_CHILD_CHANGE,
      value: nModel,
      data: key
    });
  };
  const renderPopup = onClose => {
    const onPlacementChange = e => {
      onEvent({
        type: ModelMapEditor.EVT_CHILD_CHANGE,
        value: e.value,
        data: key
      });
    };
    return /*#__PURE__*/_jsx(Pane, {
      variant: "dialogContent|dialogBody",
      children: /*#__PURE__*/_jsx(PlacementEditor, {
        value: value,
        onChange: onPlacementChange
      })
    });
  };
  return /*#__PURE__*/_jsxs(List.Item, {
    item: item,
    ...rest,
    contentClassName: S.renderer,
    children: [/*#__PURE__*/_jsx(Checkbox, {
      value: Model.getVisible(value) !== false,
      eventData: "setVisible",
      onChange: onChange
    }), /*#__PURE__*/_jsx(Text, {
      variant: "listItemSubtitle",
      children: name
    }), /*#__PURE__*/_jsx(Popup, {
      variant: "link",
      eventData: item,
      className: S.options,
      toggleVariant: "icon",
      toggleAttributes: {
        iconOn: 'fa fa-ellipsis-v',
        iconOff: 'fa fa-ellipsis-v'
      },
      render: renderPopup
    })]
  });
}